import { loadMermaid } from '../mermaid'

var mermaidChartId = 0;

// Code blocks with description mermaid get class .mermaid by the markdown parser
// This will be a <code> element inside a <pre> element
up.compiler('.mermaid', async (codeElement) => {
  if (document.body.dataset.mermaid !== undefined) {
    var chartDefinition = codeElement.innerText
    var preElement = codeElement.parentElement
    preElement.className = "mermaid-chart -loading"
    var mermaid = await loadMermaid()

    async function render() {
      mermaidChartId += 1
      // mermaid needs this div in order to build the svg inside it, it can be removed afterwards
      var tempDiv = document.createElement("div")
      preElement.appendChild(tempDiv)

      try {
        const { svg, _ } = await mermaid.render('mermaid-chart-' + mermaidChartId, chartDefinition)

        var chartElement = document.createElement("div")
        chartElement.innerHTML = svg
        chartElement.className = "mermaid-chart -finished"
        preElement.parentElement.replaceChild(chartElement, preElement)
      } catch (err) {
        preElement.classList.remove("-loading")
        preElement.removeChild(tempDiv)

        if (err?.constructor?.name === 'MermaidParseError') {
          // If this is a parse error, show the error message to the user
          preElement.classList.add("-error")

          var errorElement = document.createElement("div")
          errorElement.className = "mermaid-chart--error"
          errorElement.innerText = err.message
          preElement.appendChild(errorElement)
        } else {
          // Mermaid could not load due to unsupported syntax, or Mermaid used
          // an unsupported browser feature. In this case we do nothing and keep
          // displaying the Mermaid source verbatim.
        }
      }
    }

    // The browser may not have rendered yet, do the chart rendering in another task
    setTimeout(render, 0)
  }
});
